import axios, { AxiosResponse } from "axios";
import { PaginatedResult } from "../models/pagination";
import { CoreTrackingIndexDto, CoreTrackingReportItemDto } from "../models/coreTracking";
import { CoreTrackingFormValues } from "../models/inventory";
import { requests } from "./Requests";
const responseBody = <T>(response: AxiosResponse<T>) => response.data;

export const coreTracking = {
  getCoreTrackingIndex: (params: URLSearchParams) => axios.get<PaginatedResult<CoreTrackingIndexDto[]>>('/CoreTracking/getCoreTrackingIndex', { params }).then(responseBody),
  updateCoreTracking: (values: { cores: CoreTrackingFormValues[] }) => requests.put<void>(`/CoreTracking/updateCoreTracking`, values),
  getCoreTrackingReport: (params: URLSearchParams) => axios.get<CoreTrackingReportItemDto[]>('/CoreTracking/getCoreTrackingReport', { params }).then(responseBody),
}